import React from 'react';
import { FormTemplate, TextInput, useShowContextRequired } from 'ui-builder';
import { DetailsFieldGroup, UpdateGroupRequest, useDetailsFieldGroupsAdminService } from 'nekst-api';

export function UpdateGroupForm(props: { afterSubmitFunc?: () => void }) {
  const detailsFieldGroupsService = useDetailsFieldGroupsAdminService();
  const showContext = useShowContextRequired<DetailsFieldGroup>();
  const group = showContext.data!;

  return (
    <FormTemplate<UpdateGroupRequest, DetailsFieldGroup>
      title="Update Details Field Group"
      submitFormFunc={async (data) => {
        const result = await detailsFieldGroupsService.updateGroup(group.id, data);
        if (props.afterSubmitFunc) {
          props.afterSubmitFunc();
        }
        return result;
      }}
      initialData={{
        name: group.name,
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
    >
      <TextInput source="name" label="Group Name" />
    </FormTemplate>
  );
}
